import { t } from "@travily/i18n";
import { formatDate } from "@ui/lib/format-date";
import { formatPriceWhole } from "@ui/lib/format-price";
import { tv } from "@ui/lib/tv";
import { type Costs, PUBLISHED_CURRENCY } from "../../apply-household";
import { itemLabel } from "./labels";

type Item = Costs["categories"][number]["items"][number];

const lineItemList = tv({
  slots: {
    root: "flex flex-col gap-2 pt-2",
    row: "flex items-baseline justify-between gap-4",
    label: "text-neutral-700 text-sm",
    meta: "text-neutral-400 text-xs",
    amount: "text-neutral-900 text-sm tabular-nums",
  },
});

export interface LineItemListProps {
  items: Item[];
}

/** What a category is made of, line by line, so a figure can be argued with. */
export function LineItemList({ items }: LineItemListProps) {
  const styles = lineItemList();

  return (
    <div className={styles.root()}>
      {items.map((item) => (
        <div className={styles.row()} key={item.key}>
          <div>
            <p className={styles.label()}>{itemLabel(item.key)}</p>
            <p className={styles.meta()}>
              {[
                item.sample_size === null
                  ? null
                  : t("components.views.destinations.costs.provenance.sample", { count: item.sample_size }),
                item.as_of === null
                  ? null
                  : t("components.views.destinations.costs.as_of", { date: formatDate(item.as_of) }),
              ]
                .filter(Boolean)
                .join(" · ")}
            </p>
          </div>
          <span className={styles.amount()}>
            {item.p50_usd_minor === null ? "—" : formatPriceWhole(item.p50_usd_minor, PUBLISHED_CURRENCY)}
          </span>
        </div>
      ))}
    </div>
  );
}
